<section class="carousel">
  <ng-container *ngIf="!showCarousel">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
      Loading Recent {{ canvasType }}s
    </div>
  </ng-container>
  <ng-container *ngIf="canvas_listing && canvas_listing.length <= 0">
    <div class="noItems">No {{ canvasType }}s available to be shown</div>
  </ng-container>
  <ng-container *ngIf="showCarousel">
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let item of canvas_listing">
        <ng-template carouselSlide>
          <div class="slide">
            <app-canvas-tile
              [id]="item.id"
              type="tile_carousel"
              [favorited]="item.isFavorite"
              [editable]="(!item.isSystem && item.hasEdit) || false"
              [isSystem]="item.isSystem || false"
              [category]="item.category"
              [category_id]="item.category_id"
              [title]="item.name"
              [description]="item.description"
              [author]="item.owner"
              [updated]="item.updated_at"
              [canvasType]="canvasType"
              style="width: 100%"
            >
            </app-canvas-tile>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </ng-container>
</section>
